// Funções uteis que não se encaixam em outras categorias

// clona 'profundamente' um objeto , i.e., clona ele e todos os suobjetos, não funciona com métodos
export const deepCloning = <T>(x : T) => (JSON.parse(JSON.stringify(x)) as T)

/**
 * Substitui as chaves em uma string de template pelos valores correspondentes do objeto fornecido.
 * @param template A string de template contendo as chaves a serem substituídas.
 * @param data O objeto que mapeia as chaves para os valores correspondentes.
 * @returns A string resultante após a substituição das chaves pelos valores.
 */
export const replaceTemplateKeys = (template: string, data: Record<string, string | number>): string => {
    let result = template;
    Object.entries(data).forEach(([key, value]) => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      result = result.replace(regex, String(value));
    });
    return result;
}

export function isEmptyObject(obj: object): boolean {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}